import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/pagea/arrow1.webp';
import _imports_1 from '@/assets/img/pagea/arrow2.webp';
const _withScopeId = n => (_pushScopeId("data-v-03f9b7eb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "left-box"
};
const _hoisted_3 = {
  class: "swiper"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "img-box"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  class: "pointlist"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "right-box"
};
const _hoisted_13 = {
  class: "right-container"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", null, "领取你的AI游戏伙伴"), /*#__PURE__*/_createElementVNode("span", {
  class: "new-line"
}, "懂游戏，更懂你")], -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("span", null, " 二次元角色 · 贴心陪玩 · 情绪陪伴 · 智能攻略 · 唱歌 · 讲笑话 ")], -1));
const _hoisted_16 = {
  class: "login-box"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "login-title"
}, "登录试玩", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "form-label"
}, "手机号", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "form-label"
}, "验证码", -1));
const _hoisted_20 = {
  key: 1,
  class: "send-code-btn later-retry"
};
import router from "@/router";
import AliCaptcha from "@/components/aliCaptcha/index.vue";
import { onMounted, onBeforeMount, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
import { setCookie, getCookie } from "@/utils/utils";
import { useCountDown } from "@vant/use";
import { ElMessage } from "element-plus";
import { sendPhoneVerificationCode, loginRegisterShare, createInvitationCode } from "@/api/user";
const swiperCount = 6;
export default {
  __name: 'FirstPage',
  setup(__props) {
    const aliCaptchaRef = ref(null);
    const userStore = useUserStore();
    const alt = ["超多人物，供你选择", "在游戏过程中随时语音对话", "在游戏过程中陪伴你，懂游戏、也懂你", "放轻松，什么话题都可以聊,我们的对话体验会让你开心起来", "说句话就能 随时找攻略 也太方便了吧", "世界上最会 讲笑话的AI桌宠"];
    onBeforeMount(() => {
      const cookieToken = getCookie("token");
      userStore.clearUserInfo();
      if (cookieToken) {
        const web_user_id = getCookie("web_user_id");
        const phone_number = getCookie("phone_number");
        window.collectEvent("config", {
          user_unique_id: web_user_id
        });
        window.collectEvent("LoginSuccess", {
          phone: phone_number,
          channel: channel,
          page_name: "signup"
        });
        userStore.token = cookieToken;
        router.replace("chat");
      }
    });
    const currentItem = ref(1);
    function pointClick(i) {
      currentItem.value = i;
    }
    function autoPlay() {
      setInterval(() => {
        let i = currentItem.value + 1;
        if (i > swiperCount) {
          i = 1;
        }
        currentItem.value = i;
      }, 6000);
    }
    const leftClick = () => {
      let a = currentItem.value - 1;
      if (a < 1) {
        currentItem.value = swiperCount;
      } else {
        currentItem.value = a;
      }
    };
    const rightClick = () => {
      let a = currentItem.value + 1;
      if (a > swiperCount) {
        currentItem.value = 1;
      } else {
        currentItem.value = a;
      }
    };
    const loginForm = ref("");
    const phone_number = ref("");
    const verification_code = ref("");
    const isCanSend = ref(true);
    const isDialogVisable = ref(false);
    const loggingIn = ref(false); // 正在登录
    const queryParams = new URLSearchParams(window.location.search);
    const channel = queryParams.get("channel") || "";
    userStore.channel = channel;
    const onSubmit = values => {
      console.log("submit", values);
    };
    const countDown = ref(useCountDown({
      time: 60 * 1000,
      millisecond: false,
      onFinish: () => {
        isCanSend.value = true;
        countDown.value.reset();
      }
    }));

    // 验证码成功回调
    const handleCaptchaSuccess = captchaResult => {
      sendCodeWithCaptcha(captchaResult);
    };
    const handelSendPhoneVerificationCode = () => {
      loginForm.value.validate("手机号").then(() => {
        if (aliCaptchaRef.value) {
          aliCaptchaRef.value.showCaptcha();
        } else {
          console.log("验证码未初始化");
        }
      }).catch(err => {
        console.log(err);
      });
    };
    const sendCodeWithCaptcha = captchaResult => {
      window.collectEvent("im_web_get_verification_code");
      // 验证表单
      loginForm.value.validate("手机号").then(() => {
        const params = {
          country_code: "86",
          phone: phone_number.value,
          // 添加人机验证的结果参数
          lot_number: captchaResult.lot_number,
          captcha_output: captchaResult.captcha_output,
          pass_token: captchaResult.pass_token,
          gen_time: captchaResult.gen_time
        };

        // 发送验证码
        sendPhoneVerificationCode(params).then(response => {
          if ((response === null || response === void 0 ? void 0 : response.error_code) === 0) {
            isCanSend.value = false;
            countDown.value.start();
          } else {
            ElMessage.error(response.error_message);
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          // 重置验证码状态
          if (aliCaptchaRef.value) {
            aliCaptchaRef.value.resetCaptcha();
          }
        });
      }).catch(err => {
        console.log(err);
      });
    };
    const handleLogin = () => {
      if (!loggingIn.value) {
        loginForm.value.validate().then(() => {
          loggingIn.value = true;
          loginRegisterShare({
            country_code: "86",
            phone: phone_number.value,
            phone_verify_code: verification_code.value
          }, (err, response) => {
            if ((response === null || response === void 0 ? void 0 : response.error_code) === 0) {
              loggingIn.value = false;
              jumpToNextPage(response);
            } else if ((response === null || response === void 0 ? void 0 : response.error_code) === 41004) {
              createInvitationCode().then(res => {
                const invitation_code = res.payload.code;
                loginRegisterShare({
                  country_code: "86",
                  phone: phone_number.value,
                  phone_verify_code: verification_code.value,
                  invitation_code,
                  source: channel
                }, (err, response) => {
                  loggingIn.value = false;
                  if (err) {
                    console.log(err);
                  } else {
                    window.bilicm.mbase.report_data(); // B站上报
                    gdt("track", "REGISTER", {}); // 腾讯上报
                    window.zhad.push({
                      eventtype: "js_submit"
                    }); // 知乎上报
                    // 360上报
                    (function (w, n) {
                      w[n] = typeof w[n] === "function" ? w[n] : function () {
                        (w[n].c = w[n].c || []).push(arguments);
                      };
                      _qha("send", {
                        et: 33,
                        ct: 51,
                        customData: ["custom", "jzqu51", /*reg_id*/"", ""]
                      });
                    })(window, "_qha");
                    window.collectEvent("im_web_registered_user", {
                      phone: phone_number.value
                    });
                    jumpToNextPage(response);
                  }
                });
              }).catch(err => {
                loggingIn.value = false;
                console.log(err);
              });
            } else {
              loggingIn.value = false;
              ElMessage.error(response.error_message);
              window.collectEvent("im_web_login_error", {
                api: "loginRegisterShare",
                response
              });
            }
          });
        }).catch(err => {
          loggingIn.value = false;
          console.log(err);
        });
      }
    };
    const jumpToNextPage = response => {
      window.collectEvent("config", {
        user_unique_id: response.payload.web_user_id
      });
      window.collectEvent("LoginSuccess", {
        phone: phone_number.value,
        channel: channel,
        page_name: "signup"
      });
      setCookie("token", response.payload.access_token, 7);
      setCookie("web_user_id", response.payload.web_user_id, 7);
      setCookie("phone_number", phone_number.value, 7);
      const accessToken = response.payload.access_token;
      userStore.token = accessToken;
      userStore.seqId = 0; // 重置聊天进度
      router.replace("chat");
    };
    onMounted(() => {
      autoPlay();
    });
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_loading = _resolveComponent("van-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "arr1",
        onClick: leftClick
      }, _hoisted_5), _createElementVNode("div", {
        class: "arr2",
        onClick: rightClick
      }, _hoisted_7), _createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(swiperCount, i => {
        return _createElementVNode("img", {
          class: _normalizeClass({
            activeimg: i == currentItem.value
          }),
          src: require(`@/assets/img/pagea/in${i}1.webp`),
          alt: alt[i - 1]
        }, null, 10, _hoisted_9);
      }), 64)), _createElementVNode("div", _hoisted_10, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(swiperCount, i => {
        return _createElementVNode("div", {
          class: "pointouter",
          onClick: $event => pointClick(i)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["point", {
            active: i == currentItem.value
          }])
        }, null, 2)], 8, _hoisted_11);
      }), 64))])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("div", _hoisted_16, [_hoisted_17, _createVNode(_component_van_form, {
        ref_key: "loginForm",
        ref: loginForm,
        class: "login-form",
        "validate-first": "",
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_hoisted_18, _createVNode(_component_van_field, {
          modelValue: phone_number.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => phone_number.value = $event),
          class: "my-field",
          name: "手机号",
          rules: [{
            required: true,
            message: '请填写手机号',
            trigger: 'onBlur'
          }, {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式错误，请更换后重试',
            trigger: 'onBlur'
          }]
        }, null, 8, ["modelValue"]), _hoisted_19, _createVNode(_component_van_field, {
          modelValue: verification_code.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => verification_code.value = $event),
          class: "my-field",
          name: "验证码",
          rules: [{
            required: true,
            message: '请填写验证码',
            trigger: 'onBlur'
          }, {
            pattern: /^\d{6}$/,
            message: '验证码错误',
            trigger: 'onBlur'
          }]
        }, {
          button: _withCtx(() => [isCanSend.value ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "send-code-btn",
            onClick: handelSendPhoneVerificationCode
          }, "发送验证码")) : _createCommentVNode("", true), !isCanSend.value ? (_openBlock(), _createElementBlock("span", _hoisted_20, "重新发送 (" + _toDisplayString(countDown.value.current.seconds) + "s)", 1)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 512), _createVNode(AliCaptcha, {
        ref_key: "aliCaptchaRef",
        ref: aliCaptchaRef,
        onSuccess: handleCaptchaSuccess
      }, null, 512), _createElementVNode("div", {
        class: "login-btn",
        onClick: handleLogin
      }, [_createElementVNode("p", null, [_createTextVNode(" 登录 "), loggingIn.value ? (_openBlock(), _createBlock(_component_van_loading, {
        key: 0,
        type: "spinner",
        size: "24px",
        style: {
          "margin-left": "0.04rem"
        }
      })) : _createCommentVNode("", true)])])])])])]);
    };
  }
};